<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.inspectorId" hidden/>

      <t-input label="Inspetor vinculado a usuário da plataforma?"
               help="Deixe como Não somente se desejar cadastrar um inspetor que não possua acesso, entretando você poderá inserir Inspetores de forma rápida através do cadastro de usuários, onde é possível inclusive habilitar acesso somente via código."
               v-model="yesOrNotLinkUser" :options="yesOrNotOptions"
               radio/>

      <div v-show="onYesLinkUser">

        <t-input v-model="form.userId" :options="usersOptions" :add-error="error.userId"
                 label="Usuário da plataforma"  :required="onYesLinkUser" select/>

      </div>


      <div v-show="!onYesLinkUser">

        <t-input v-model="form.name"  :add-error="error.name" label="Nome" :required="!onYesLinkUser"/>

      </div>

      <t-input v-model="form.inspectorCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
               :add-error="error.inspectorCodeLabel" upper
               label="Cód. Inspetor"
               help="Código inserido manualmente conforme configurado em Locais > Configurações > Parâmetros"
               required/>

      <t-input v-model="form.inspectorCodeLabel"
               v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
               :add-error="error.inspectorCodeLabel" upper
               fixed
               label="Cód. Inspetor"
               help="Código inserido automaticamente conforme configurado em Agentes > Configurações > Parâmetros"
      />
      
      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import userService from "@/services/modules/setting/User.service";
import SettingType from "@/model/types/resource/SettingType";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'InspectorForm',

  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "inspectorId",
      form: {
        inspectorId: 0,
        inspectorNumber:0,
        inspectorCodeLabel: "",
        userId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        inspectorCodeLabel: "",
        userId: "",
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      yesOrNotLinkUser: "N", //Valor padrão não possui vinculo com usuário
      usersOptions: [],



      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    async onSubmit() {


      if(this.yesOrNotLinkUser === 'N'){
        this.form.userId = 0
      }

      await this.setSendingDefault()


    },
    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await userService.selectList("").then((list) => {
        this.usersOptions = list
      }).catch(error => this.responseError(error))



      this.pageFormIsLoaded = true

      if (this.form.userId > 0) {
        this.yesOrNotLinkUser = "Y"
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {
    onYesLinkUser() {
      return this.yesOrNotLinkUser === 'Y'
    }
  }

}
</script>
